import { render } from "./OTPInvitationVerifyForm.vue?vue&type=template&id=7e00aaeb&ts=true"
import script from "./OTPInvitationVerifyForm.vue?vue&type=script&lang=ts"
export * from "./OTPInvitationVerifyForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/UserForm/OTPInvitationVerifyForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e00aaeb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e00aaeb', __exports__)) {
    api.reload('7e00aaeb', __exports__)
  }
  
  module.hot.accept("./OTPInvitationVerifyForm.vue?vue&type=template&id=7e00aaeb&ts=true", () => {
    api.rerender('7e00aaeb', render)
  })

}


export default __exports__